import React, { Component } from 'react';
import { Trans, withTranslation } from "react-i18next";
import './UnsubscribePopUp.scss';
import "../../scss/buttons.scss";

class UnsubscribePopUp extends Component {
    render() {
        return (            
        <div className="snippetload-overlay-wrapper">
            <div className="auth-popup">
            <div className="mx-5 mt-4"><Trans i18nKey={
                    "unsubscribePopUp#text"} components={{u:<u/>}}></Trans></div>
                <div className="text-center mt-4">
                    <button className="button mx-3" title={this.props.t("unsubscribePopUp#confirm#title")} onClick={() => { this.props.removePopUp(); this.props.handleSubmit() }}>{this.props.t("unsubscribePopUp#confirm#label")}</button>
                    <button className="button button-green mx-3" title={this.props.t("unsubscribePopUp#cancel#title")} onClick={this.props.removePopUp}>{this.props.t("unsubscribePopUp#cancel#label")}</button>
                </div>
            </div>
        </div>
       )
    }
}
export default withTranslation()(UnsubscribePopUp);
